import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  evaluationResults: [],
  trustAttributes: {},
  computedScores: {
    overallTrustScore: 0,
    categoryScores: {
      Accuracy: 0,
      Fairness: 0,
      Security: 0,
      Privacy: 0,
      Robustness: 0,
      Explainability: 0,
      Ethics: 0,
    },
    riskLevel: '',
    recommendations: [],
  },
  loading: false,
  error: null,
};

const testScoreSlice = createSlice({
  name: 'testScore',
  initialState,
  reducers: {
    setEvaluationResults: (state, action) => {
      state.evaluationResults = action.payload;
    },
    setTrustAttributes: (state, action) => {
      state.trustAttributes = action.payload;
    },
    setComputedScores: (state, action) => {
      state.computedScores = { ...state.computedScores, ...action.payload };
    },
    setTestScoreData: (state, action) => {
      return { ...state, ...action.payload, loading: false, error: null };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetTestScore: () => initialState,
  },
});

export const {
  setEvaluationResults,
  setTrustAttributes,
  setComputedScores,
  setTestScoreData,
  setLoading,
  setError,
  resetTestScore,
} = testScoreSlice.actions;

export default testScoreSlice.reducer;
